import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Runs once, at module-evaluation time — before React's first render, let
// alone its first effect. The browser's own scroll restoration (default
// "auto") remembers scroll position per history entry and silently restores
// it on load/navigation, in a race against this component's own reset
// below. On a fresh load of a URL the browser has scroll history for, that
// restoration can land — and Header's own mount-time scroll check can read
// it — before our effect (below) gets a chance to zero it out, producing a
// brief but real flash of the "scrolled" (white) header state even though
// the page visually renders at the top. Turning restoration off hands scroll
// position entirely to this component, with nothing left to race.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export default function PageScrollTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A hash means the page wants to scroll to a specific anchor (see
    // TherapeuticAreas.jsx) — jumping to the top first would just race it.
    if (hash) return;
    // The site sets `scroll-behavior: smooth` on :root (App.css), which makes
    // the plain scrollTo(0, 0) form an ANIMATED scroll instead of an instant
    // jump. React Router swaps in an entirely new page's DOM right around
    // the same time, and that large a DOM mutation reliably cancels an
    // in-progress smooth-scroll animation before it moves the page at all —
    // so this was silently doing nothing on every navigation, leaving each
    // new page exactly as scrolled as the one before it. `behavior: "instant"`
    // bypasses the CSS setting and always actually resets the scroll.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}